// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TemplateGroup } from '@interfaces/document.interfaces';
import { AppEvent } from '@interfaces/interfaces';

@Component({
    selector: 'template-groups',
    templateUrl: './template-groups.component.html',
    styleUrls: ['./template-groups.component.scss'],
})
export class TemplateGroupsComponent implements OnInit {
    @Input() groups: TemplateGroup[];
    @Input() templateGroupSelection: TemplateGroup;
    @Output() public outEvent: EventEmitter<AppEvent> = new EventEmitter();
    public selectedValue: TemplateGroup = null;

    constructor(private readonly route: ActivatedRoute) {}

    ngOnInit(): void {
        if (this.templateGroupSelection) {
            this.selectedValue = this.templateGroupSelection;
        }
    }

    sortByProducts(value: number) {
        this.outEvent.emit({
            context: 'selected-group',
            data: value,
        });
    }
}
